import { CommonModule, DatePipe } from "@angular/common";
import { Component, ElementRef, Input, ViewChild, SecurityContext } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
import { RouterLink } from "@angular/router";
import { Modal, ModalService } from "@indice/ng-components";
import { TranslocoDirective, TranslocoService } from "@jsverse/transloco";
import { AuthService } from "src/app/core/services/auth.service";
import { PortalApiService, PropertyDetails } from "src/app/services/portal-api.service";
import { FavoriteAnonymousModalComponent } from "src/app/shared/components/favorite-anonymous-modal/favorite-anonymous-modal.component";
import { LanguageRouterLinkDirective } from "src/app/shared/directives/language-router-link.directive";
import { ShareDirective } from "src/app/shared/directives/share.directive";

@Component({
  selector: 'app-property-description',
  standalone: true,
  templateUrl: './property-description.component.html',
  styleUrl: `./property-description.component.css`,
  imports: [CommonModule, TranslocoDirective, LanguageRouterLinkDirective, ShareDirective, DatePipe]
})
export class PropertyDescriptionComponent {
  public descriptionOpen: boolean = false;
  public accordionApproved: boolean = false;
  public auctionDateFormatted: Date | null = null;
  public auctionRoundNumberSuffix: string = 'ος';
  public buildShareText: string = '';
  public shareUrl: string = '';

  isLoggedIn: boolean = false;
  @Input() public model: PropertyDetails | undefined;
  @ViewChild('nbgApprove', { static: false }) set nbgApprove(element: ElementRef | undefined) {
    if (element) {
      const flaggedText = '$$preApproveAmount';
      const replacementText = this.model?.preApprovalAmmount;
      element.nativeElement.innerHTML = this.sanitizer.sanitize(SecurityContext.HTML, element.nativeElement.innerHTML.replace(
        flaggedText,
        replacementText
      ));
    }
  }
  protected activeLanguage: string = 'el';
  protected preapprovalDescr: string = '';

  public toggleDescription() {
    this.descriptionOpen = !this.descriptionOpen;
  }

  constructor(
    private authService: AuthService,
    private apiService: PortalApiService,
    private _modalService: ModalService,
    private _translate: TranslocoService,
    private sanitizer: DomSanitizer
  ) {
    this.authService.isLoggedIn().subscribe(x => this.isLoggedIn = x);
  }
  ngOnInit(): void {
    this.activeLanguage = this._translate.getActiveLang();
    if (this.activeLanguage === 'en') {
      this.preapprovalDescr = this.model?.preApprovalDescription?.en ?? this.model?.preApprovalDescription?.el ?? '';

      if (this.model?.auctionRound) {
        switch (this.model?.auctionRound) {
          case 1:
            this.auctionRoundNumberSuffix = 'st';
            break;
          case 2:
            this.auctionRoundNumberSuffix = 'nd';
            break;
          case 3:
            this.auctionRoundNumberSuffix = 'rd';
            break;
          default:
            this.auctionRoundNumberSuffix = 'th';
        }
      }
    } else {
      this.preapprovalDescr = this.model?.preApprovalDescription?.el ?? this.model?.preApprovalDescription?.en ?? '';
      this.auctionRoundNumberSuffix = 'ος';
    }

    if (this.model?.auctionDateTime) {
      const auctionDateTime = new Date(this.model?.auctionDateTime);
      this.auctionDateFormatted = auctionDateTime;
    }

    this.buildShareText = `Περιοχή: ${this.model?.address ? this.model.address.prefecture : ''} | ID: ${this.model?.code} | Τιμή: ${this.model?.price}€`
    this.shareUrl = window.location.href;
  }


  public toggleAccordionApproved() {
    this.accordionApproved = !this.accordionApproved;
  }

  toggleFavorite(event: any) {
    event.stopPropagation();
    if (this.isLoggedIn) {
      this.apiService.togglePropertyFavorite(this.model?.id ?? '').subscribe({
        next: () => {
          if (this.model) {
            this.model.isFavorite = !this.model?.isFavorite;
          }
        }
      });
    }
    else {
      let favoriteAnonymousModal: Modal<FavoriteAnonymousModalComponent> = new Modal<FavoriteAnonymousModalComponent>;

      favoriteAnonymousModal = this._modalService.show(FavoriteAnonymousModalComponent, {
        keyboard: true,
        class: 'h-dvh md:h-auto',
      })
    }
  }
}
